import { Grid, Typography } from '@mui/material'
import EditIcon from "@mui/icons-material/Edit";
import FlagIcon from '@mui/icons-material/Flag';
import React, { useState, useEffect } from 'react'
import AddRatingModal from './AddRatingModal';

const CommentRating = (props) => {
  const { title, data, action, templateId, categoryId, lineUuid, commentUuid, commentIndex, component, editComment, ratingValue, setRatingValue, matches, lineIndex, descriptionDisabled } = props
  const [ratings, setRatings] = useState([])
  const [showRatingModal, setShowRatingModal] = useState(false)
  useEffect(() => {
    setRatings(data !== null && data !== undefined && data?.data !== null && data?.data?.length !== 0 ? (data?.data || data) : [])
  }, [data])

  const renderRating = (rating) => (
    <div
      className="rating_square_container"
      key={rating.Id}
      style={{ display: "flex", alignItems: "center" }}
    >
      <div
        className="rating_square"
        style={{ background: `${rating.Color}`, padding: "4px" }}
      >
        {Number.parseInt(String(rating?.include_in_summary ?? 0), 10) === 1 ? <FlagIcon /> : null}
      </div>
      <div className="rating_name_text" style={{ marginRight: component === "line_outside" ? "5px" : "20px", textOverflow: component === "line_outside" && "ellipsis", overflow: component === "line_outside" && "hidden", whiteSpace: component === "line_outside" && "nowrap", width: component === "line_outside" ? (descriptionDisabled ? "85px" : "105px") : "auto" }}>{rating.Name}</div>
    </div>
  )

  return (
    <>
      <AddRatingModal
        showRatingModal={showRatingModal}
        setShowRatingModal={setShowRatingModal}
        ratings={ratings}
        templateId={templateId}
        categoryId={categoryId}
        lineUuid={lineUuid}
        commentUuid={commentUuid}
        component={component}
        editComment={editComment}
        ratingValue={ratingValue}
        setRatingValue={setRatingValue}
      />
      {component === "line_outside" && (!ratings || ratings?.length === 0 || ratingValue || ratingValue?.length === 0) ? <p
        className={`line_content_rating ${matches ? "responsive" : ""}`}
        id={`add_comment_btn_${lineIndex + 1}`}
        onClick={() => setShowRatingModal(true)}
        style={{ height: descriptionDisabled && "36px" }}
      >
        <FlagIcon />
        {!matches && <span>Add line rating</span>}{" "}
      </p > : <Grid container={descriptionDisabled ? false : true} item mb={component === "line_inside" ? 2.5 : 0} pl={component === "line_inside" ? 2 : 0} xs={descriptionDisabled ? 6 : component === "line_outside" ? 3 : 12} className={`${action === "line" ? "container" : (component === "commentModal" || component === "line_outside" || component === "line_inside") ? "" : "inner_container"}`} >
        <Grid item xs={12} className={(component === "commentModal" || component === "line_outside") ? "" : "line_detail_des_title"} id={`edit_rating_title_${commentIndex + 1}`} onClick={() => setShowRatingModal(true)} sx={{ ":hover": { cursor: "pointer !important" }, marginBottom: component === "commentModal" ? "8px" : "0px" }}>
          {component !== "line_outside" ? <span className={`${(action === "line" || action === "line_level") ? "details_title" : component === "commentModal" ? "non-narrative-comment-label" : "inner_details_title"}`}> {title}</span> : null}
        </Grid>
        <Typography
          size="large"
          type="text"
          multiline
          id={`edit_rating_${commentIndex + 1}`}
          onClick={() => setShowRatingModal(true)}
          sx={{
            outline: "1px solid #c1c1c1",
            padding: ratings?.length > 0 || ratingValue?.length > 0 ? "3.5px" : "5.5px",
            position: "relative",
            minWidth: "100%",
            borderRadius: component === "line_outside" ? "2px" : "4px",
            ":hover": { cursor: "pointer !important" },
            paddingBottom: component === "line_outside" ? "0px !important" : null,
            paddingTop: descriptionDisabled ? "3px !important" : component === "line_outside" ? "5px !important" : null,
            height: descriptionDisabled ? "34px" : component === "line_outside" ? "38px" : null,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "7px",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "0px 10px",
              minHeight: "24px",
              ":hover": { cursor: "pointer" },
            }}
            onClick={() => setShowRatingModal(true)}
          >
            {(component === "commentModal" || component === "line_inside" || component === "comment") &&
              (!Array.isArray(ratings) || ratings.length === 0) &&
              (!Array.isArray(ratingValue) || ratingValue.length === 0) && (
                <div style={{ height: "20px", textTransform: "normal", color: "#000000", opacity: "0.4", fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
                  No rating selected
                </div>)}
            {(component === "line_outside"
              ? (Array.isArray(ratings) && ratings.length > 0
                ? [ratings[0]]
                : Array.isArray(ratingValue) && ratingValue.length > 0
                  ? [ratingValue[0]]
                  : [])
              : component === "commentModal"
                ? (Array.isArray(ratingValue) ? ratingValue : [])
                : (Array.isArray(ratings) ? ratings : [])
            ).map((rating) => renderRating(rating))}
            <span className="edit-text"></span>
            {component !== "line_outside" ? <EditIcon
              id={`edit_rating_icon_${commentIndex + 1}`}
              onClick={() => setShowRatingModal(true)}
              sx={{
                color: "#252525 !important",
                cursor: "pointer",
                marginRight: "12px",
              }}
              style={{
                position: "absolute",
                right: "0",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            /> : null}
          </div>
        </Typography>
      </Grid >
      }
    </>
  );
}

export default CommentRating